const penileMass= [

     
    {
    label:"Size (cm)",
    controlType:"text",
    options:[]
    },

    {
    label:"Mass or Ulcer",
    controlType:"radio button",
    options:["Mass", "Ulcer", "Ulcerating mass"]
    },

    { 
    label:"Area involved",
    controlType:"checkbox group",
    options:["Base", "Shaft", "Glans", "Foreskin"]
    },
    
    { 
    label:"Consistency:",
    controlType:"radio button",
    options:["Hard", "Soft"]
    },

    { 
    label:"Texture:",
    controlType:"radio button",
    options:["Smooth", "Irregular"]
    },

    { 
    label:"Pain:",
    controlType:"radio button",
    options:["Painful", "Painless"]
    },

    { 
    label:"Tenderness:",
    controlType:"radio button",
    options:["Tender", "Non-tender"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    
]


export default penileMass